export enum CampaignType {
  NORMAL = "normal",
  AFFILIATE = "affiliate",
}
